import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';
import {UtilsService} from '../common/utils/utils.service';

@Injectable()
export class ToastService {

  public toaster: any;
  public stopToastError = false;
  private defaultToastTimeout = 3000;
  private errorToastTimeout = 3500;
  private waitForToastErrorTimeout: number = this.errorToastTimeout + 10;

  constructor(public toasterService: ToastrService,
              private utilsService: UtilsService) {
  }

  showSuccessToaster(text, title = 'Ottimo :-)', config = {timeOut: this.defaultToastTimeout}): void {
    this.toasterService.success(text, title, config);
  }

  showInfoToaster(text, title = '', config = {timeOut: this.defaultToastTimeout}): void {
    this.toasterService.info(text, title, config);
  }

  showToasterWarning(text): void {
    this.stopToastError = true;
    this.toasterService.warning(text, 'Attenzione!', {
      timeOut: this.errorToastTimeout,
      closeButton: true,
      progressBar: true
    });
  }

  showToasterError(text: string): void {
    if (!this.stopToastError) {
      this.stopToastError = true;
      const toaster = this.toasterService.error(text, 'Oops... Qualcosa è andato storto!', {
        timeOut: this.errorToastTimeout,
        closeButton: true,
        progressBar: true
      });
      toaster.onHidden = new Observable(() => {
        this.goErrorToast();
      });
      this.waitForToastError();
    }
  }

  private goErrorToast(): void {
    this.stopToastError = false;
  }

  private waitForToastError(): void {
    this.utilsService.delay(this.waitForToastErrorTimeout).then(() => this.goErrorToast());
  }

}
